// src/store/familyStore.js
import { create } from 'zustand'
import ApiClient from '../views/api/client'
import { toast } from 'react-toastify'

const apiClient = new ApiClient()

export const useFamilyStore = create((set) => ({
  familyMembers: {},
  addMembers: {},
  member: {},
  loading: false,
  error: '',
  color: '',
  showDeleteModal: false,
  showUpdateModal: false,
  showAddModal: false,
  updateMember: null,
  memberToDelete: null,

  // modal for deleting client
  openDeleteModal: (client) => {
    set({ showDeleteModal: true, memberToDelete: client })
  },

  closeDeleteModal: () => {
    set({ showDeleteModal: false, memberToDelete: null })
  },

  // modal for updating client
  openUpdateModal: (client) => {
    set({ updateMember: client, showUpdateModal: true })
  },

  closeUpdateModal: () => {
    set({ updateMember: null, showUpdateModal: false })
  },

  // modal for adding new client
  openAddModal: () => {
    set({ showAddModal: true })
  },

  closeAddModal: () => {
    set({ showAddModal: false })
  },

  setColor: (color) => {
    set({ color: color })
  },

  // Fetch family members
  fetchFamilyMembers: async (clientId) => {
    set({ loading: true, error: '' })
    try {
      const res = await apiClient.getClientFamily(clientId)
      set((state) => ({
        familyMembers: {
          ...state.familyMembers,
          [clientId]: res.data, // store by clientId
        },
        loading: false,
      }))
    } catch (err) {
      console.error('Error fetching family members:', err)
      set({
        error: err.response?.data?.detail || 'Failed to load family members',
        loading: false,
      })
    }
  },

  getAFamilyMember: async (memberId) => {
    set({ loading: true, error: '' })
    try {
      const res = await apiClient.getAFamilyMember(memberId)
      set((state) => ({
        member: {
          ...state.member,
          [memberId]: res.data,
        },
        loading: false,
      }))
    } catch (err) {
      set({ error: err.response?.data?.detail, loading: false })
    }
  },

  addFamilyMember: async (clientId, name, email, image, relationship, age) => {
    set({ laoding: true })
    try {
      const res = await apiClient.addFamilyMember(
        clientId,
        name,
        email,
        image,
        relationship,
        age
      )
      set((state) => ({
        addMembers: {
          ...state.addMembers,
          [clientId]: res.data,
        },
        laoading: false,
      }))
      if (res.data) {
        // toast.success('Family member successfully added!', {
        //   position: 'top-right',
        //   autClose: 3000,
        //   theme: 'colored',
        // })
      }
    } catch (err) {
      set({ error: err.response?.data?.detail })
      if (err) {
        // toast.error(`Error occured ${err}`, {
        //   position: 'top-right',
        //   autClose: 3000,
        //   theme: 'colored',
        // })
      }
    }
  },

  setError: (err) => set({ error: err }),
}))
